import uniqid from "uniqid";

let PVData = [];
/*
  PersonalData = [],
  PVLocation = [];

PersonalData["Vorname"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Nachname"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Geburtsort"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Geburtsdatum"] = {
  type: "date",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Steuernummer"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Provinz (Abkürzung, maximal 2 Zeichen ,z.B. BZ für Bozen)"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
  maxlength: "2",
};
PersonalData["Gemeinde"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Straße"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Hausnummer"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Postleitzahl"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Steuernummer"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Partita Iva"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: false,
};
PersonalData["Telefonnummer"] = {
  type: "tel",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Email"] = {
  type: "mail",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["IBAN"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["IBAN laufend auf"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PersonalData["Privatperson"] = {
  type: "radio",
  key: uniqid(),
  content: "",
  required: true,
  selectedValue: "Ja",
};
PVData["Baubeginn"] = {
  type: "date",
  key: uniqid(),
  content: "",
  required: true,
};
PVData["Name PV-Anlage"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PVData["Spitzenleistung[kW]"] = {
  type: "number",
  key: uniqid(),
  content: "",
  required: true,
};
PVData["Nennleistung[kW]"] = {
  type: "number",
  key: uniqid(),
  content: "",
  required: true,
};
PVData["POD"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PVData["Speicher"] = {
  type: "radio",
  key: uniqid(),
  required: true,
  content: "",
  leistung: "",
  selectedValue: "Ja",
};
PVLocation["Provinz (Abkürzung, maximal 2 Zeichen ,z.B. BZ für Bozen)"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
  maxlength: "2",
};
PVLocation["Gemeinde"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PVLocation["Fraktion"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PVLocation["Straße"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PVLocation["Nummer"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PVLocation["Kataster-Blatt"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PVLocation["Kataster-Parzelle"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PVLocation["Kataster-Sub."] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: false,
};
let Signature = {
  filename: [],
};
let id = {
  filename: [],
};
let bill = {
  filename: [],
};
let Cadastral = {
  filename: [],
};
*/
PVData["Vorname"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PVData["Nachname"] = {
  type: "text",
  key: uniqid(),
  content: "",
  required: true,
};
PVData["Bauende"] = {
  type: "date",
  key: uniqid(),
  content: "",
  required: true,
};
let Konform = {
  filename: [],
};
let Spiii = {
  filename: [],
};

export { PVData, Konform, Spiii };
